<template>
	<Modal
		v-if="shown"
		:title="titleText"
		@close="show(false)"
		:close-on-click-outside="false"
		:width="1600"
	>
		<template v-slot:body>
			<div>
				<div class="text_center font_bold gray_light_color trackPay_status">
					<span v-if="detail.status && detail.status === enumDef.trackPayStats.Arrived">{{ $t("trackPay.trackProgressModal.delivered") }}</span>
				</div>
				<div class="flex">
					<TrackMap
						ref="trackMap"
						:trackNum="shipmentUnitId"
						:locationList="locationList"
					></TrackMap>
					<div class="flex_1 trackModal_right">
						<TrackDetail :row-data="detail"></TrackDetail>
						<TrackDetailTable :row-data="details" @changeUnit="changeUnit"></TrackDetailTable>
					</div>
				</div>
			</div>
			<div class="flex flex_between margin_top">
				<div></div>
				<md-button @click="show(false)" class="md-blank"
				>{{ $t("common.close") }}
				</md-button>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from "src/components/templates/modal/Modal";
import TrackMap from "./TrackMap";
import TrackDetail from "./TrackDetail";
import TrackDetailTable from "./TrackDetailTable";
import {trackPayApi} from "src/common/api/trackPayApi";
import {enumDef} from "@/common/enumDefs";

export default {
	props: {
		isDebtor: Boolean
	},
	components: {
		Modal,
		TrackMap,
		TrackDetail,
		TrackDetailTable,
	},
	data() {
		let activeTypes = {
			debtorData: "debtor",
			debtorContacts: "contacts",
			creditManagement: "creditManagement",
			debtorDocuments: "documents",
		};

		return {
			editMode: false,
			shown: false,
			activeTypes: activeTypes,
			activeType: activeTypes.debtorData,
			contractData: null,
			details: [],
			locationList: [],
			shipmentUnitId: "",
			detail: {}
		};
	},
	computed: {
		enumDef() {
			return enumDef
		},
		titleText() {
			return this.$t("trackPay.trackProgressModal.trackingProgress");
		}
	},
	methods: {
		changeUnit(res) {
			this.locationList = res.previousLocations.map((item) => [item.longitude, item.latitude]);
			this.shipmentUnitId = res.shipmentUnitId;
		},
		show(value, data) {
			this.details = [];
			this.shown = value;
			if (data) {
				this.detail = data.data;
				let call = (this.isDebtor ? trackPayApi.debtor : trackPayApi.seller).getLocationsByShipment(data.data.shipmentId);
				call.then(res => {
						res.shipmentUnits.forEach(unit => {
							if (unit.previousLocations && unit.previousLocations.length > 0) {
								this.details.push({
									shipmentUnitId: unit.id,
									lastUpdated: unit.lastSeenTS,
									isLocation: true,
									isShock: true,
									isTemperature: false,
									isAirPressure: false,
									isHumidity: false,
									previousLocations: unit.previousLocations
								});
							}
						});
					})
					.catch(err => this.toast("Error getting locations: " + err));

				// this triggers possibly a rerender of TrackDetailTable which has to be built properly before that, so we wait here
				setTimeout(() => {
					if (this.details[0]) {
						this.changeUnit(this.details[0]);
					}
				}, 500);
			}
		},
		showTrackingProgress(data) {
			this.show(true);
			this.editMode = false;
			this.activeType = this.activeTypes.debtorData;
			this.contractData = data;
		},
		showTrackingDetails(data) {
			this.show(true, data);
			this.editMode = true;
			this.activeType = this.activeTypes.debtorData;
			this.contractData = data;
		}
	}
};
</script>
<style lang="scss" scoped>
.trackPay_status {
	margin-bottom: 30px;
}

.trackModal_right {
	margin-left: 100px;
}
</style>
